
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import Toolbar from './domains/global/components/Toolbar.vue'
import NavigationDrawer from './domains/global/components/NavigationDrawer.vue'

@Component({
  name: 'App',
  components: { Toolbar, NavigationDrawer }
})
export default class App extends Vue {
  showNav: boolean | null = null

  get showToolbar () {
    const route = this.$route || { meta: { public: true } }
    return !route?.meta?.public
  }

  get items () {
    const isTranslationAgency = this.$store.state.auth.isTranslationAgency
    const items = [
      { title: 'Dashboard', icon: 'dashboard', path: '/dashboard', show: true },
      { title: 'Jobs', icon: 'assignment', path: '/jobs', show: true },
      { title: 'Customers', icon: 'face', path: '/customers', show: isTranslationAgency },
      { title: 'Customer Invoices', icon: 'receipt', path: '/customer-invoices', show: true },
      { title: 'Languages', icon: 'translate', path: '/translation-services', show: isTranslationAgency },
      { title: 'Extended Pool Config', icon: 'pool', path: '/pool-config', show: isTranslationAgency },
      { title: 'Pricing', icon: 'sell', path: '/pricing', show: isTranslationAgency },
      { title: 'Reporting', icon: 'summarize', path: '/reporting', show: isTranslationAgency },
      { title: 'Relationships', icon: 'groups', path: '/relationships', show: isTranslationAgency },
      { title: 'My Users', icon: 'manage_accounts', path: '/users', show: true },
      { title: 'My Providers', icon: 'group', path: '/providers', show: isTranslationAgency },
      { title: 'Service Receipts', icon: 'receipt', path: '/service-receipts', show: isTranslationAgency },
      { title: 'Translation Receipts', icon: 'receipt', path: '/translation-receipts', show: isTranslationAgency },
      { title: 'Distributors', icon: 'group', path: '/distributors-relationship', show: isTranslationAgency },
      { title: 'Issues', icon: 'assignment_late', path: '/issues', show: true },
      { title: 'My Webhooks', icon: 'web', path: '/webhooks', show: true }
    ]

    return items.filter(i => i.show)
  }

  get showSuccess() {
    return this.$store.state.success.showing
  }

  set showSuccess(value: boolean) {
    if (!value) {
      this.$store.commit('HIDE_SUCCESS')
    }
  }

  get showError() {
    return this.$store.state.error.showing
  }

  set showError(value: boolean) {
    if (!value) {
      this.$store.commit('HIDE_ERROR')
    }
  }

  toggleNav () {
    this.showNav = !this.showNav
  }
}
